import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import { Alert } from "@mui/material";
import { AlertTriangle } from "lucide-react";

const ProtectedRouteByYear = ({ children }) => {
  const selectedYear = useSelector((state) => state.user.selectedYear);
  const [restrictAccessByYear, setRestrictAccessByYear] = useState(selectedYear.id <= 0);
  const [showWarning, setShowWarning] = useState(false);
  const [shouldNavigate, setShouldNavigate] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user')) || { company: { id: null, name: null } };
    
    if(user.role_code === 'ADMIN') {
      setRestrictAccessByYear(false);
      setShowWarning(false);
      return;
    }

    if (selectedYear.id > 0) {
      setRestrictAccessByYear(false);
      setShowWarning(false);
    } else {
      setRestrictAccessByYear(true);
      setShowWarning(true);
    }
  }, [selectedYear]);

  const handleConfirm = () => {
    setShowWarning(false);
    setShouldNavigate(true);
  };

  if (shouldNavigate) {
    return <Navigate to="/account/data-reporting-year" />;
  }

  if (restrictAccessByYear) {
    return (
      <Dialog
        open={showWarning}
        onClose={() => { }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 1
          }
        }}
      >
        <DialogTitle sx={{
          fontSize: '1.5rem',
          fontWeight: 600,
          pt: 2,
          pb: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <AlertTriangle size={24} color="#ff9800" /> {/* Warning icon */}
          Reporting Year Required
        </DialogTitle>
        <DialogContent>
          <Alert severity="warning" sx={{ mb: 2 }}>
            <DialogContentText sx={{ color: 'text.primary' }}>
              Please select a reporting year to access other menus. You will be redirected to the year selection page.
            </DialogContentText>
          </Alert>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button
            variant="contained"
            onClick={handleConfirm}
            sx={{
              textTransform: 'none',
              px: 3,
              py: 1,
              borderRadius: 1,
              backgroundColor: '#ff9800', // Orange color to match warning theme
              '&:hover': {
                backgroundColor: '#fb8c00', // Darker orange on hover
              }
            }}
          >
            Continue to Year Selection
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return children;
};

export default ProtectedRouteByYear;